import { css } from 'emotion';

import { colors, fonts } from '../styles';

export const editIcon = css`
  flex-shrink: 0;
  margin: 0 5px;
  height: 12px;
  width: 10px;
  color: ${colors.gray.default};
`;

export const editableLabel = css`
  outline: none;
  white-space: nowrap;
  display: inline-block;
  padding: 5px;
  size: ${fonts.size.medium};

  &:focus {
    background-color: ${colors.gray.lightest};
  }

  &[placeholder]:empty::before {
    content: attr(placeholder);
    color: ${colors.gray.default};
  }
`;

export const editableContainer = css`
  display: flex;
  align-items: center;
  max-width: 100%;
  cursor: text;

  &:hover {
    background-color: ${colors.gray.lightest};

    & .${editIcon} {
      color: ${colors.gray.dark};
    }
  }
`;

export const labelContainer = css`
  overflow: hidden;
`;
